import { gql } from '@apollo/client';

// Query to get CSV template headers for a team
export const GET_IMPORT_TEMPLATE = gql`
  query GetImportTemplate($teamId: ID!) {
    teamContactImportTemplate(teamId: $teamId)
  }
`;

// Mutation to import contacts
export const IMPORT_TEAM_CONTACTS = gql`
  mutation ImportTeamContacts($teamId: ID!, $contactsData: [JSON!]!) {
    importTeamContacts(teamId: $teamId, contactsData: $contactsData) {
      total
      successful
      failed
      duplicatesSkipped
      failedRows {
        row
        data
        errors
      }
      error
    }
  }
`;
